var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.offices,"label":_vm.$t('invoices.international_offices'),"value":_vm.value},model:{value:(_vm.office),callback:function ($$v) {_vm.office=$$v},expression:"office"}})}
var staticRenderFns = []

export { render, staticRenderFns }